import React from "react"
import { IIconProps } from "../Elements/Global/atoms/Icons/Icon/Interfaces"

const UploadIcon = ({ width = 20, height = 20 }: IIconProps) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 231 345"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect x="23.498" width="207" height="270" fill="#ECECEC" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M159.683 0V70.9889H230.672L159.683 0Z"
				fill="#C2C2C2"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M230.672 70.9893L230.672 0.000311931L159.683 0.000305725L230.672 70.9893Z"
				fill="white"
			/>
			<path d="M39.498 249L56.498 270H22.498L39.498 249Z" fill="white" />
			<path d="M73.998 249L91.498 270H56.498L73.998 249Z" fill="white" />
			<path d="M109.498 249L127.498 270H91.498L109.498 249Z" fill="white" />
			<path d="M143.998 249L160.498 270H127.498L143.998 249Z" fill="white" />
			<path d="M178.498 249L196.498 270H160.498L178.498 249Z" fill="white" />
			<path d="M213.498 249L230.498 270H196.498L213.498 249Z" fill="white" />
			<path
				d="M103.766 162.981H97.1753V174.256H85.8659V162.981H62.498V154.981L86.5025 119.856H97.1753V154.051H103.766V162.981ZM85.8659 154.051V144.823C85.8659 143.285 85.9283 141.053 86.0531 138.126C86.1779 135.198 86.2778 133.499 86.3527 133.028H86.0531C85.1294 135.062 84.0184 137.047 82.7202 138.981L72.684 154.051H85.8659Z"
				fill="#252F5E"
			/>
			<path
				d="M146.045 147.056C146.045 156.557 144.473 163.589 141.327 168.153C138.206 172.718 133.388 175 126.872 175C120.556 175 115.787 172.643 112.567 167.93C109.371 163.217 107.773 156.259 107.773 147.056C107.773 137.456 109.334 130.386 112.454 125.847C115.575 121.282 120.381 119 126.872 119C133.188 119 137.957 121.381 141.177 126.144C144.423 130.907 146.045 137.878 146.045 147.056ZM119.27 147.056C119.27 153.729 119.844 158.516 120.992 161.419C122.166 164.296 124.126 165.735 126.872 165.735C129.568 165.735 131.516 164.271 132.714 161.344C133.912 158.417 134.511 153.654 134.511 147.056C134.511 140.383 133.9 135.595 132.676 132.693C131.478 129.766 129.543 128.302 126.872 128.302C124.151 128.302 122.203 129.766 121.03 132.693C119.857 135.595 119.27 140.383 119.27 147.056Z"
				fill="#252F5E"
			/>
			<path
				d="M180.498 174.256H168.926V142.777L169.039 137.605L169.226 131.949C167.304 133.859 165.968 135.112 165.219 135.707L158.928 140.73L153.348 133.809L170.986 119.856H180.498V174.256Z"
				fill="#252F5E"
			/>
			<rect
				x="55.7578"
				y="287.665"
				width="15.9308"
				height="80.4079"
				rx="7.96542"
				transform="rotate(-45 55.7578 287.665)"
				fill="#C2C2C2"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M39.0306 297.907C60.5865 297.907 78.0611 280.432 78.0611 258.876C78.0611 237.32 60.5865 219.846 39.0306 219.846C17.4746 219.846 0 237.32 0 258.876C0 280.432 17.4746 297.907 39.0306 297.907ZM39.0307 291.06C56.8049 291.06 71.2138 276.651 71.2138 258.876C71.2138 241.102 56.8049 226.693 39.0307 226.693C21.2565 226.693 6.84762 241.102 6.84762 258.876C6.84762 276.651 21.2565 291.06 39.0307 291.06Z"
				fill="#C4C4C4"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M39.0306 290.738C56.6273 290.738 70.8923 276.473 70.8923 258.876C70.8923 241.28 56.6273 227.015 39.0306 227.015C21.4339 227.015 7.16895 241.28 7.16895 258.876C7.16895 276.473 21.4339 290.738 39.0306 290.738ZM39.0307 285.148C53.5402 285.148 65.3026 273.386 65.3026 258.876C65.3026 244.367 53.5402 232.604 39.0307 232.604C24.5211 232.604 12.7587 244.367 12.7587 258.876C12.7587 273.386 24.5211 285.148 39.0307 285.148Z"
				fill="white"
			/>
		</svg>
	)
}

export default UploadIcon
